export default {
  name: 'KpiBaseDataEdit',
  data () {
    return {
      elData: null,
      isLoading: false
    }
  },
  methods: {
    submitForm () {
      this.isLoading = true;
      this.ApiRequest.request('kpi/user-base-data/' + this.elData.id, this.ApiRequest.REQUEST_POST, this.elData.user_kpi_data, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this, { 'item.code': 'general.item.code' });
        } else {
          this.$emit('saved', response.data);
          this.close();
        }
        this.isLoading = false;
      });
    },
    show (elData) {
      this.elData = elData;
      if (!this.elData.user_kpi_data) {
        this.elData.user_kpi_data = { salary: null, kpi_bonus_rate: 16.7, period_type: null };
      }
      this.$refs['modal-window'].show();
    },
    close (elData) {
      this.$refs['modal-window'].hide();
    }
  },
  computed: {
    periodTypes () {
      const periodTypes = this.$store.getters.getConfigOptions('period_types', this.$i18n.locale);
      periodTypes.forEach(periodType => {
        periodType.text = this.$t('general.period_types.' + periodType.value);
      });
      return periodTypes;
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  mounted () {
  }
}
